var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeltip"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('el-tooltip',{attrs:{"placement":"top-start","effect":"dark"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.tip))]),_c('i',{staticClass:"el-icon-info tip"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }